import { ApiData } from 'states/types'
import { IncidentReport } from 'types/incident-report'

const Types = {
  SET: '@@incident-report/SET',
  ADD: '@@incident-report/ADD',
  UPDATE: '@@incident-report/UPDATE',
  LOADING: '@@incident-report/LOADING'
}

export type Payload = ApiData<IncidentReport>

export { Types }
